import { Dialog } from "primereact/dialog";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { IBranchMastDropdown, ICompanyMastDropdown } from "../../../models/IDropdown";
import { baseUrl, Fetch, ILazyParams } from "../../../shared/Fetch";
import { IModel } from "./RFP_Bid_TeamManagement";
import { BidTeamEmptySkillFilter, IBidTeamSkillFilter } from "./Filter";

interface Iprops {
  singleData: any;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
  setModal?: (modal: IModel) => void;
  setModal3?: (modal: { open: boolean; singleData: any; inTeam: any }) => void;
  inTeam?: any;
}

interface Users {
  branch_ID?: number;
  login_ID?: number;
  user_Name?: string;
}

interface Team {
  branch?: string;
  branch_ID?: number;
  company?: string;
  company_ID?: number;
  createdOn?: Date;
  status?: boolean;
  team_ID?: number;
  team_Manager?: string;
  team_Manager_ID?: number;
  team_Name?: string;
  user_Added_by?: number;
}

interface RowData {
  login_ID: number;
  teamMember_ID: number;
  team_ID: number;
  user_Name: string;
}

export const RFPBidTeamMemberForm = (props: Iprops) => {
  const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
  const [company, setCompany] = useState(null as ICompanyMastDropdown | null);
  const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
  const [branch, setBranch] = useState(null as IBranchMastDropdown | null);
  const [diable, setDisable] = useState({ branch: true, teamMembers: true });
  const [users, setUsers] = useState<Array<Users>>();
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>; loading: boolean });
  const [moveModal, setMoveModal] = useState({ open: false, user_ID: 0 } as { open: boolean; user_ID: number });
  const [team, setTeam] = useState<Array<Team>>([]);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
  const [disableOnSubmit, setDisableOnSubmit] = useState(false);
  const [disableOnSubmitMoveModal, setDisableOnSubmitMoveModal] = useState(false);
  const [disableMove, setDisableMove] = useState(false);
  const [disableRemove, setDisableRemove] = useState(false);
  const [skillFilter, setSkillFilter] = useState<IBidTeamSkillFilter>(BidTeamEmptySkillFilter);

  const [lazyParams, setLazyParams] = useState<ILazyParams>({
    first: 0,
    rows: 25,
    page: 1,
    sortField: "consultant_ID",
    sortOrder: -1,
  });

  let x: string | null = sessionStorage.getItem("auth") || "null";
  let loginObj = JSON.parse(x);

  const loadTeamMembers = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("RFP_Bid_TeamMember", "GET", null, `team_Id=${props.singleData.team_ID}`, null);
    if (response) {
      const data = await response.json();
      setTableData({ tableData: data, loading: false });
    }
  };

  const loadCompanies = async () => {
    setBranch(null);
    const response = await Fetch("Dropdown/company", "GET", null, null, null);
    if (response) {
      const data: Array<ICompanyMastDropdown> = await response.json();
      setCompanies(data);
    }
  };

  const loadBranches = async () => {
    setUsers([]);
    const response = await Fetch("Dropdown/branches", "GET", null, `company_id=${company}`, null);
    if (response) {
      const data: Array<IBranchMastDropdown> = await response.json();
      setBranches(data);
    }
  };

  const loadUsers = async () => {
    const response = await Fetch("RPF_Bid_Team_Management/BidUsersByBranch", "GET", null, `branch_ID=${branch}`, null);
    if (response) {
      const data: Array<Users> = await response.json();
      let resp = [];
      for (let i = 0; i < data.length; i++) {
        let yes = true;
        for (let j = 0; j < tableData.tableData.length; j++) {
          if (data[i].login_ID === tableData.tableData[j].login_ID) {
            yes = false;
            j = tableData.tableData.length;
          }
        }
        if (yes) {
          resp.push(data[i]);
        }
      }
      setUsers(resp);
    }
  };

  const loadTeams = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    // const query = `lazyParams=${encodeURIComponent(JSON.stringify(lazyParams))}` + `&filters=${encodeURIComponent(JSON.stringify(skillFilter))}`;
    const response = await Fetch("RPF_Bid_Team_Management", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filters=${JSON.stringify(skillFilter)}`, props.toast);
    if (response) {
      const data: Array<Team> = await response.json();
      setTeam(data);
    }
  };

  useEffect(() => {
    loadCompanies();
    if (props.open) {
      loadTeamMembers();
      setSelectedTeamMembers([]);
      setSelectedTeam([]);
      if (company != null) {
        setDisable({ branch: false, teamMembers: true });
        loadBranches();
      } else {
        setDisable({ branch: true, teamMembers: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);
  useEffect(() => {
    if (company != null) {
      loadBranches();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);
  useEffect(() => {
    if (branch != null) {
      loadUsers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);
  useEffect(() => {
    loadTeams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moveModal.open]);

  const saveToDB = async (body: any) => {
    const teamMembersList = body.list.map((el: number) => {
      let user = {
        Team_ID: body.ud === 0 ? props.singleData.team_ID : body.ud,
        Login_ID: el,
        Status: true,
        Added_By: loginObj.id,
        Added_On: null,
      };
      return user;
    });

    const response = await Fetch("RFP_Bid_TeamMember", "POST", teamMembersList, null, props.toast);
    if (response) {
      const resp = await response.json();

      loadTeamMembers();
      setSelectedTeamMembers([]);
      setSelectedTeam([]);
      setDisableOnSubmit(false);
      setDisableOnSubmitMoveModal(false);

      if (!resp.success) {
        props.toast.current.show({ severity: "warn", detail: resp.message, life: 3000 });

        let list = resp.notAvailableUsers.filter((el: { on_Team_ID: number }) => el.on_Team_ID !== props.singleData.team_ID);
        if (list.length > 0) {
          props.setModal3?.({ singleData: list, open: true, inTeam: props.singleData });
        }
        props.setReload(!props.reload);
      } else {
        props.toast.current.show({ severity: "success", detail: resp.message, life: 3000 });
        props.setReload(!props.reload);
      }
    } else setDisableOnSubmit(false);
  };

  const selectCompany = (e: ICompanyMastDropdown) => {
    setCompany(e);
    setBranch(null);
    if (e) {
      setDisable({ branch: false, teamMembers: true });
    } else {
      setDisable({ branch: true, teamMembers: true });
    }
  };
  const selectBranch = (e: IBranchMastDropdown) => {
    setBranch(e);
    if (e) {
      setDisable({ branch: false, teamMembers: false });
    } else {
      setDisable({ branch: false, teamMembers: true });
    }
  };

  const onHide = () => {
    props.hideDialog();
    setBranch(null);
    setCompany(null);
    setUsers([]);
    setSelectedTeamMembers([]);
  };
  const onHideMoveModal = () => {
    setMoveModal({ open: false, user_ID: 0 });
    loadTeamMembers();
    setSelectedTeam([]);
  };

  function onSubmit() {
    if (selectedTeamMembers.length === 0) {
      props.toast.current.show({ severity: "error", detail: "Please select atleast one team member", life: 3000 });
      setDisableOnSubmit(false);
    } else {
      setDisableOnSubmit(true);
      saveToDB({ list: selectedTeamMembers, ud: 0 });
    }
  }

  async function onMove() {
    setDisableOnSubmitMoveModal(true);
    let resp = await removeMember({ id: moveModal.user_ID, r: false });
    if (resp) saveToDB({ list: [moveModal.user_ID], ud: selectedTeam });
    onHideMoveModal();
  }

  async function removeMember(data: { id: number; r: boolean }) {
    setDisableRemove(true);
    const params = {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
    };

    const response = await fetch(`${baseUrl}RFP_Bid_TeamMember?user_IDs=${[data.id]}`, params);
    if (response) {
      props.toast.current.show({ severity: "success", detail: "Member Removed", life: 3000 });
      if (data.r) {
        loadTeamMembers();
      }
      setDisableRemove(false);
      return true;
    }
  }

  const MoveRemove = (rowData: RowData) => {
    return (
      <div className="w-full flex justify-content-evenly">
        <Button className="w-5rem" disabled={disableMove} onClick={() => setMoveModal({ open: true, user_ID: rowData.login_ID })}>
          Move
        </Button>
        <Button className="w-6rem" disabled={disableRemove} onClick={() => removeMember({ id: rowData.login_ID, r: true })}>
          Remove
        </Button>
      </div>
    );
  };

  return (
    <>
      <Dialog visible={props.open} style={{ width: "80vw" }} header="Add/Edit Bid Team Members" modal className="p-fluid" onHide={onHide}>
        <div className="flex">
          <Panel header="Bid Team Name" className="w-3">
            <p className="m-0">{props.singleData?.team_Name}</p>
          </Panel>
          <Panel header="Company" className="w-3">
            <p className="m-0">{props.singleData?.company}</p>
          </Panel>
          <Panel header="Branch" className="w-3">
            <p className="m-0">{props.singleData?.branch}</p>
          </Panel>
          <Panel header="Team Manager" className="w-3">
            <p className="m-0">{props.singleData?.team_Manager}</p>
          </Panel>
        </div>
        <div className="flex align-content-center mt-6 gap-3">
          <div>
            <label>Company</label>
            <Dropdown value={company} onChange={(e: any) => selectCompany(e.value)} options={companies} optionValue="company_ID" optionLabel="company_Name" placeholder="Select a Company" className="w-full md:w-14rem" showClear />
          </div>
          <div>
            <label>Branch</label>
            <Dropdown value={branch} disabled={diable.branch} onChange={(e: any) => selectBranch(e.value)} options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select a Branch" className="w-full md:w-14rem" showClear />
          </div>
        </div>
        <div className="flex align-content-center mt-3 gap-3">
          <MultiSelect value={selectedTeamMembers} disabled={diable.teamMembers} onChange={(e) => setSelectedTeamMembers(e.value)} options={users} optionValue="login_ID" optionLabel="user_Name" display="chip" filter placeholder="Select Members" maxSelectedLabels={10} className="w-11" />
          <Button disabled={disableOnSubmit} className="h-3rem w-6rem" onClick={onSubmit}>
            SUBMIT
          </Button>
        </div>
        <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} className="mt-6" size="small" stripedRows scrollable scrollHeight="30vh" value={tableData.tableData} emptyMessage="No Team Members found." loading={tableData.loading}>
          <Column header="SN." body={(data, options) => options.rowIndex + 1} />
          <Column field="user_Name" header="Team Member Name" />
          <Column field="company" header="Company Name" />
          <Column field="branch" header="Branch Name" />

          <Column field="" header="" body={MoveRemove} />
        </DataTable>
      </Dialog>
      <Dialog visible={moveModal.open} style={{ width: "30vw" }} header="Move To Another Team" modal className="p-fluid" onHide={onHideMoveModal}>
        <div className="flex w-full justify-content-between">
          <Dropdown showClear value={selectedTeam} onChange={(e) => setSelectedTeam(e.value)} options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select a Team" className="w-full md:w-14rem" />
          <Button className="w-5rem" disabled={disableOnSubmitMoveModal} onClick={onMove}>
            Move
          </Button>
        </div>
      </Dialog>
    </>
  );
};
